import React, { useEffect, useLayoutEffect } from 'react';
import { Route, Routes as ReactRoutes, useLocation } from 'react-router-dom';
import { Logout } from '@cognite/react-container';

import { useMetrics } from '@cognite/metrics';
import StartPage from '../StartPage';
import SearchAsset from '../Search';
import ProjectContainer from '../../containers/ProjectContainer';

const LogoutPage = () => {
  const metrics = useMetrics('Logout');
  metrics.track('logout');

  useEffect(() => {
    // router issue
    // logout could be moved to root of applications
    // manual cleanup
    localStorage.clear();
  }, []);

  return <Logout />;
};

const Routes = () => {
  const location = useLocation();

  // on page change scroll to top
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <ReactRoutes>
      <Route path="/" element={<StartPage />} />
      <Route path="/search" element={<SearchAsset />} />
      <Route path="/logout" element={<LogoutPage />} />

      <Route path="/project/*" element={<ProjectContainer />} />
    </ReactRoutes>
  );
};

export default Routes;
